import PropTypes from 'prop-types'
import React, { memo } from 'react'
import { structure } from '@dofleini/location'
import { Select } from 'antd'

const { Option } = Select
const { PROVINCES } = structure

const Provinces = ({
  value,
  onChange,
  multiple,
  maxItems,
  canClear,
  canSearch,
  ...props
}) => {
  return (
    <Select
      mode={multiple ? 'multiple' : 'default'}
      allowClear={canClear}
      style={{ minWidth: 150 }}
      maxTagCount={maxItems || 3}
      onChange={onChange}
      defaultValue={value}
      value={value}
      showSearch={canSearch}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      {Object.keys(PROVINCES).map((prov) => (
        <Option key={PROVINCES[prov].code} value={PROVINCES[prov].acronym}>
          {PROVINCES[prov].name}
        </Option>
      ))}
    </Select>
  )
}

export default memo(Provinces)

Provinces.propTypes = {
  canClear: PropTypes.bool,
  canSearch: PropTypes.bool,
  maxItems: PropTypes.number,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array])
}
